var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"admin-lang-switcher",attrs:{"value":_vm.locale},on:{"change":_vm.handleLocaleChange}},_vm._l((_vm.options),function(item,index){return _c('el-option',{key:index,attrs:{"value":item.value,"label":item.label}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }